import { useWindowDimensions } from "react-native";
import { screenSizes } from "../configs/screenSizes";
import { DeviceType, deviceType } from "expo-device";

export const useIsScreenSizeMin = (maxSize: keyof typeof screenSizes) => {
    const { width } = useWindowDimensions();

    if (
        deviceType === DeviceType.TABLET &&
        (maxSize === "large" || maxSize === "extraLarge" || maxSize === "extraExtraLarge")
    ) {
        return false;
    }

    return width > screenSizes[maxSize];
};
